import { NavigationGuardNext, RouteLocationNormalized } from "vue-router";

export const subdomainParamKey = 'subdomain';

export default async function injectSubdomainAsRouteParam(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext): Promise<void>
{
    to.params[subdomainParamKey] = window.location.hostname.split('.')[0];
    next();
}
